import { useRoute, useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26bcaf44"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "third-party-detail-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "订单明细", -1));
const _hoisted_3 = {
  class: "table-content"
};
const _hoisted_4 = {
  class: "filter-content"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = {
  class: "right"
};
import { exportBillDetail, getBillDetails } from '@/api/thirdParty';
import { message } from 'ant-design-vue';
import { awaitWrap, OK } from '@/common';
import { usePagination } from '@/hooks/usePagination';
import { useTimer } from '@/views/thirdPartyBill/hooks/useTimer';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'thirdPartyBillDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const {
      timer,
      getExportFile
    } = useTimer();
    const route = useRoute();
    const router = useRouter();
    const columns = [{
      title: '渠道',
      dataIndex: 'payChnl',
      key: 'payChnl'
    }, {
      title: '交易时间',
      dataIndex: 'dateTime',
      key: 'dateTime'
    }, {
      title: '三方订单号',
      dataIndex: 'thirdOrderNo',
      key: 'thirdOrderNo'
    }, {
      title: '多比特订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '订单金额',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '退款金额',
      dataIndex: 'refundAmount',
      key: 'refundAmount'
    }, {
      title: '手续费',
      dataIndex: 'commissionAmount',
      key: 'commissionAmount'
    }, {
      title: '交易类型',
      dataIndex: 'payStatus',
      key: 'payStatus'
    }];
    const dataSource = ref([]);
    const loading = ref(false);
    const searchObj = ref({});
    const fetchData = async () => {
      loading.value = true;
      let [err, data] = await awaitWrap(getBillDetails({
        pageNum: pageIndex.value,
        pageSize: pageSize.value,
        ...searchObj.value
      }));
      if (data && data.code === OK) {
        dataSource.value = data.data.list;
        pageTotal.value = data.data.total;
      }
      if (err) {
        message.error('获取数据失败');
      }
      loading.value = false;
    };
    const exportExcel = async () => {
      var _dataSource$value;
      if (!((_dataSource$value = dataSource.value) !== null && _dataSource$value !== void 0 && _dataSource$value.length)) return false;
      let params = {
        ...searchObj.value
      };
      const [err, data] = await awaitWrap(exportBillDetail(params));
      if (data && data.code === OK) {
        if (timer.value) return message.error('导出中，请稍后');
        timer.value = setInterval(() => {
          var _data$data;
          getExportFile((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.taskId);
        }, 1000);
      }
      if (err) {}
    };
    const {
      pageIndex,
      pageSize,
      pageTotal,
      currentPageSizeChange
    } = usePagination(fetchData);
    onMounted(() => {
      //payChnls 取搜索条件的
      //payChnl取行，没有传null
      //datePeriod 取搜索条件的
      // startDate endDate 取搜索条件的
      // dateTime  datePeriod==sum 不传 取每行的
      searchObj.value = {
        dbtIds: [route.query.dbtId],
        payChnl: route.query.payChnl || null,
        payChnls: route.query.payChnls,
        startDate: route.query.startDate,
        endDate: route.query.endDate,
        billType: route.query.billType,
        payStatus: route.query.type === 'order' ? '20' : '30',
        datePeriod: route.query.datePeriod,
        currency: route.query.currency
      };
      if (route.query.dateTime) {
        searchObj.value = {
          ...searchObj.value,
          dateTime: route.query.dateTime
        };
      }
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
      }, {
        default: _withCtx(() => [_createTextVNode("返回")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
        type: "primary",
        class: "export-btn",
        onClick: exportExcel,
        loading: !!_unref(timer)
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      }, 8, ["loading"])])]), _createVNode(_component_a_table, {
        columns: columns,
        "data-source": dataSource.value,
        bordered: "",
        pagination: false,
        loading: loading.value
      }, null, 8, ["data-source", "loading"]), _createVNode(_component_a_pagination, {
        total: _unref(pageTotal),
        current: _unref(pageIndex),
        "onUpdate:current": _cache[1] || (_cache[1] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        "show-size-changer": "",
        "page-size": _unref(pageSize),
        onChange: _unref(currentPageSizeChange)
      }, null, 8, ["total", "current", "page-size", "onChange"])])]);
    };
  }
});